import { render, staticRenderFns } from "./PerfisUsuarioWizardStepper.vue?vue&type=template&id=f136283a&scoped=true&"
import script from "./PerfisUsuarioWizardStepper.vue?vue&type=script&lang=js&"
export * from "./PerfisUsuarioWizardStepper.vue?vue&type=script&lang=js&"
import style0 from "./PerfisUsuarioWizardStepper.vue?vue&type=style&index=0&id=f136283a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f136283a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
